import { alpha } from "@material-ui/core/styles/colorManipulator";
export var createMuiRadioOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette, transitions = _a.transitions;
    return ({
        root: {
            padding: "calc(".concat(spacing(4), "px - 0.75rem)"),
            borderRadius: "50%",
            "& [class*='MuiSvgIcon-root']": {
                transition: transitions.create(["fill", "stroke", "color", "background-color"], {
                    duration: transitions.duration.shorter,
                }),
            },
        },
        colorPrimary: {
            "& [class*='MuiSvgIcon-root']": {
                stroke: palette.text.secondary,
            },
            "&&$checked [class*='MuiSvgIcon-root']": {
                color: palette.common.white,
                fill: palette.primary.main,
                stroke: palette.background.default,
            },
            "&:hover, &&$checked:hover, &.Mui-focusVisible": {
                backgroundColor: palette.action.hover,
            },
            "&.Mui-focusVisible [class*='MuiSvgIcon-root']": {
                stroke: palette.text.primary,
            },
            "&:active, &&$checked:active": {
                backgroundColor: alpha(palette.text.primary, 0.24),
            },
            "&$disabled": {
                color: palette.text.primary,
            },
        },
        disabled: {
            opacity: palette.action.disabledOpacity,
        },
    });
};
//# sourceMappingURL=MuiRadio.js.map